import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../../../../redux';
import { updateFormatOption } from '../../../../redux/ChartPoperties/ChartControlsActions';

/**
 *
 * This component is rendered by GaugeChartFormatting
 * @returns UI component containing calculated and non calculated buttons for percent
 */

const PercentageCalculateButtons = ({
  searchIn,
  propKey,
  iconColor,
}: {
  searchIn: string;
  propKey: string;
  iconColor?: string;
}) => {
  const { gaugeChartFormats } = useSelector((state: RootState) => ({
    gaugeChartFormats: state.chartControls.properties[propKey].formatOptions.gaugeChartFormats,
  }));

  const dispatch = useDispatch();
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          marginTop: '-10px',
          marginBottom: '10px',
        }}
      >
        <span className="optionDescription" style={{ color: iconColor }}>
          Percent Type
        </span>
        <div className="radioButtons" style={{ padding: '0' }}>
          <div
            className={
              gaugeChartFormats[searchIn]?.percentageCalculate === true
                ? 'radioButtonSelected'
                : 'radioButton'
            }
            style={{
              backgroundColor:
                gaugeChartFormats[searchIn]?.percentageCalculate === true
                  ? 'rgba(224, 224, 224, 1)'
                  : 'white',
              cursor:
                gaugeChartFormats[searchIn]?.percentageCalculate === true ? 'auto' : 'pointer',
              fontWeight:
                gaugeChartFormats[searchIn]?.percentageCalculate === true ? '600' : 'normal',
            }}
            onClick={() => {
              const updatedValue = { ...gaugeChartFormats[searchIn], percentageCalculate: true };
              dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
            }}
          >
            Calculated
          </div>
          <div
            className={
              gaugeChartFormats[searchIn]?.percentageCalculate === false
                ? 'radioButtonSelected'
                : 'radioButton'
            }
            style={{
              backgroundColor:
                gaugeChartFormats[searchIn]?.percentageCalculate === false
                  ? 'rgba(224, 224, 224, 1)'
                  : 'white',
              cursor:
                gaugeChartFormats[searchIn]?.percentageCalculate === false ? 'auto' : 'pointer',
              fontWeight:
                gaugeChartFormats[searchIn]?.percentageCalculate === false ? '600' : 'normal',
            }}
            onClick={() => {
              const updatedValue = { ...gaugeChartFormats[searchIn], percentageCalculate: false };
              dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
            }}
          >
            Non Calculated
          </div>
        </div>
      </div>
    </>
  );
};

export default PercentageCalculateButtons;
